<template>
    <div class="contentLayout">
        <div class="contentNavigationBar">
            <h2 class="title">방문자 통계</h2>
        </div>
        <div class="contentBody">
            <!-- 검색 조건 -->
            <div class="searchBar">
                <div class="columnDivision-3">
                    <div class="labelWrap">
                        <label>기간</label>
                        <input
                            type="date"
                            class="inputBox"
                            v-model="searchForm.startDate"
                        />
                    </div>
                    <div class="labelWrap">
                        <label class="textCenter" style="width: 30px">-</label>
                        <input
                            type="date"
                            class="inputBox"
                            v-model="searchForm.endDate"
                        />
                    </div>
                </div>
                <button class="searchBtn" @click="selectVisitorStatsInfo()">
                    조회하기
                </button>
            </div>
            <h3 class="contentTitle">방문현황</h3>
            <table class="infoTable tableFixed">
                <thead>
                    <tr>
                        <th class="textCenter">방문자수</th>
                        <th class="textCenter">방문횟수</th>
                        <th class="textCenter">신규방문자수</th>
                        <th class="textCenter">재방문자수</th>
                        <th class="textCenter">방문당PV</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="textCenter">
                            {{ visitorStatsInfo.visitorCount | makeComma }}
                        </td>
                        <td class="textCenter">
                            {{ visitorStatsInfo.visitCount | makeComma }}
                        </td>
                        <td class="textCenter">
                            {{ visitorStatsInfo.newVisitorCount | makeComma }}
                        </td>
                        <td class="textCenter">
                            {{ visitorStatsInfo.reVisitorCount | makeComma }}
                        </td>
                        <td class="textCenter">
                            {{ visitorStatsInfo.visitorPageView | makeComma }}
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="contentTitleWrap marginTop-50">
                <h3 class="contentTitle">방문현황 그래프</h3>
                <div class="titleBtnWrap">
                    <button
                        :class="[
                            'titleRadiusBtn',
                            chartTab[0] == 1 ? 'bgType2' : 'bgType1',
                        ]"
                        @click="setDayChart()"
                    >
                        일간
                    </button>
                    <button
                        :class="[
                            'titleRadiusBtn',
                            chartTab[1] == 1 ? 'bgType2' : 'bgType1',
                        ]"
                        @click="setYearmonthChart()"
                    >
                        월간
                    </button>
                    <button
                        :class="[
                            'titleRadiusBtn',
                            chartTab[2] == 1 ? 'bgType2' : 'bgType1',
                        ]"
                        @click="setYearChart()"
                    >
                        년간
                    </button>
                </div>
                <div style="height: 500px">
                    <VueApexCharts
                        v-if="isShowChart"
                        width="100%"
                        height="500"
                        type="line"
                        :options="options"
                        :series="series"
                    ></VueApexCharts>
                </div>
            </div>
            <table class="infoTable tableFixed">
                <tbody></tbody>
            </table>
            <!-- <h3 class="contentTitle marginTop-50">인기 페이지</h3>
            <table class="infoTable tableFixed">
                <tbody></tbody>
            </table>
            <h3 class="contentTitle marginTop-50">방문자 정보</h3>
            <table class="infoTable tableFixed">
                <tbody></tbody>
            </table> -->
        </div>
    </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";

/*Chart*/
import VueApexCharts from "vue-apexcharts";
Vue.use(VueApexCharts);

export default {
    name: "VisitorStats",
    components: {
        VueApexCharts,
    },
    created() {
        this.siteNo = this.$route.params.siteNo;
        this.setDefaultPeriod();
        this.selectVisitorStatsInfo();
    },
    data() {
        return {
            siteNo: "",
            searchForm: {
                startDate: "",
                endDate: "",
            },
            visitorStatsInfo: {
                visitorCount: "",
                visitCount: "",
                newVisitorCount: "",
                reVisitorCount: "",
                visitorPageView: "",
                visitDayChart: [],
                visitYearmonthChart: [],
                visitYearChart: [],
            },
            options: {
                chart: {
                    id: "visitorChart",
                    animations: {
                        enabled: false,
                    },
                    toolbar: { show: false },
                },
                dataLabels: {
                    enabled: true,
                    enabledOnSeries: [0, 1, 2],
                },
                stroke: {
                    width: [3, 0, 3],
                    curve: "straight",
                },
                markers: {
                    size: 4,
                },
                plotOptions: {
                    bar: {
                        columnWidth: "45%",
                        borderRadius: 2,
                        dataLabels: { position: "top" },
                    },
                },
                legend: {
                    position: "top",
                },
                colors: ["#008FFB", "#00E396", "#FF4560"],
                xaxis: {
                    type: "category",
                },
            },
            series: [
                {
                    name: "방문자수",
                    type: "line",
                    data: [],
                },
                {
                    name: "순 IP(distinct)",
                    type: "bar",
                    data: [],
                },
                {
                    name: "봇",
                    type: "line",
                    data: [],
                },
            ],
            isShowChart: false,
            chartTab: [1, 0, 0],
        };
    },
    methods: {
        // 기간 기본값: 당월 1일 ~ 오늘
        setDefaultPeriod() {
            const now = new Date();
            const pad = (n) => String(n).padStart(2, "0");
            const y = now.getFullYear();
            const m = pad(now.getMonth() + 1);
            const d = pad(now.getDate());
            this.searchForm.startDate = y + "-" + m + "-01";
            this.searchForm.endDate = y + "-" + m + "-" + d;
        },
        selectVisitorStatsInfo() {
            axios
                .post(
                    this.config.contextRoot +
                        "/visitor/selectVisitorStatsInfo.do",
                    {
                        siteNo: this.siteNo,
                        startDate: this.searchForm.startDate,
                        endDate: this.searchForm.endDate,
                    }
                )
                .then((response) => {
                    this.visitorStatsInfo = response.data.visitorStatsInfo;

                    //기본 세팅 일간차트
                    this.setDayChart();
                });
        },
        // 차트 데이터(방문자수 라인 + 순 IP 막대) 세팅
        renderChart(chartData) {
            const list = chartData || [];
            this.isShowChart = false;
            this.series = [
                {
                    name: "방문자수",
                    type: "line",
                    data: list.map((d) => ({ x: d.x, y: Number(d.y) })),
                },
                {
                    name: "순 IP(distinct)",
                    type: "bar",
                    data: list.map((d) => ({ x: d.x, y: Number(d.ip) })),
                },
                {
                    name: "봇",
                    type: "line",
                    data: list.map((d) => ({ x: d.x, y: Number(d.bot) })),
                },
            ];
            this.$nextTick(() => {
                this.isShowChart = true;
            });
        },
        setDayChart() {
            this.chartTab = [1, 0, 0];
            this.renderChart(this.visitorStatsInfo.visitDayChart);
        },
        setYearmonthChart() {
            this.chartTab = [0, 1, 0];
            this.renderChart(this.visitorStatsInfo.visitYearmonthChart);
        },
        setYearChart() {
            this.chartTab = [0, 0, 1];
            this.renderChart(this.visitorStatsInfo.visitYearChart);
        },
    },
};
</script>

<style>
</style>